import { NumberSelectorField, NumberSelectorFieldProps } from '@/components/common/field/NumberSelectorField';
import React, { FC } from 'react';

type Props = Omit<NumberSelectorFieldProps, 'name'>;

export const SudokuCountSelectorField: FC<Props> = (props: Props) => {
  const { minValue, maxValue, helperText, ...other } = props;

  return (
    <NumberSelectorField
      name={'sudokuCount'}
      minValue={minValue}
      maxValue={maxValue}
      label={'Количество бланков судоку'}
      withLabel={true}
      isNotAbsoluteHelperText={true}
      helperText={helperText ? helperText : `Не более ${maxValue} бланков`}
      {...other}
    />
  );
};
